export default "__VITE_ASSET__DXTX9wTE__"